(() => {
  function init(root) {
    if (root.dataset.hkwReady) return;
    root.dataset.hkwReady = 'true';
    const main = root.querySelector('.hkw-main-image');
    const thumbs = [...root.querySelectorAll('.hkw-thumbnail')];
    thumbs.forEach((button, i) => button.addEventListener('click', () => {
      main.removeAttribute('srcset');
      main.src = button.dataset.src;
      main.alt = button.dataset.alt;
      thumbs.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      root.querySelector('[data-photo-status]').textContent = `Product photo ${i + 1} of ${thumbs.length}`;
    }));
    const variants = JSON.parse(root.querySelector('[data-hkw-prices]').textContent);
    const select = root.querySelector('.wbn-size');
    function price() {
      const rows = variants.filter(v => v.size === select.value).sort((a, b) => a.cents - b.cents);
      root.querySelector('[data-size-price]').textContent = rows.length ? `This size: ${rows[0].price}${rows[0].cents === rows.at(-1).cents ? '' : ' – ' + rows.at(-1).price}` : 'Review available options in the designer.';
    }
    select.addEventListener('change', price);
    price();
  }
  document.querySelectorAll('.hkw').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.hkw').forEach(init));
})();
